import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user.model';

@Component({
  selector: 'app-account-view',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './account-view.html'
})
export class AccountView implements OnInit {
  private userService = inject(UserService);

  employee: User | null = null;
  formProfile: Partial<User> = {};
  loadingProfile = false;

  ngOnInit() {
    this.userService.currentUser$.subscribe(emp => {
      this.employee = emp;
      if (emp) {
        this.formProfile = {
          name: emp.name,
          firstName: emp.firstName,
          email: emp.email,
          phone: emp.phone
        };
      }
    });
  }

  async saveProfile() {
    this.loadingProfile = true;
    try {
      await this.userService.updateCurrentUser(this.formProfile);
      alert("Profile updated!");
    } catch (e) {
      console.error(e);
      alert("Error while updating profile");
    } finally {
      this.loadingProfile = false;
    }
  }

  getTenantNames(): string {
    if (!this.employee?.tenants || this.employee.tenants.length === 0) {
      return 'No tenant';
    }
    return this.employee.tenants
      .map(ut => ut.tenant?.name || 'Unknown')
      .join(', ');
  }
}
